import {
  DataTable,
  FlexBox,
  IconButton,
  Page,
  Timestamp,
} from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';

import type { EmailDraftV2 } from 'apis/userStorage';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useServerStorage } from 'utils/useServerStorage/useServerStorage';

export const DraftsView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { data: userStorage, set: setUserStorage } = useServerStorage('user');

  const emailDraftsV2 = userStorage.drafts?.email ?? [];

  const handleEdit = (draft: EmailDraftV2) => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:composeEmail',
          arg: { draft },
        },
      }),
    );
  };

  const handleRemove = (draft: EmailDraftV2) => {
    setUserStorage({
      drafts: (storage) => {
        if (!storage.email) return;
        const idx = storage.email.findIndex(
          (d) => d.timestamp === draft.timestamp,
        );
        if (idx !== -1) storage.email.splice(idx, 1);
      },
    });
  };

  return (
    <Page>
      <Page.Head title="Email drafts" />

      <Page.Section>
        <DataTable
          data={emailDraftsV2 as EmailDraftV2[]}
          columns={[
            {
              label: 'From',
              selector: (draft) => {
                return draft.fromEmail?.[0] ?? <em>No sender</em>;
              },
            },
            {
              label: 'To',
              selector: (draft) => {
                return draft.toEmail[0]?.email ?? <em>No receiver</em>;
              },
            },
            {
              label: 'Subject',
              selector: (draft) => {
                return draft.subject || <em>No subject</em>;
              },
            },
            {
              label: 'Message',
              selector: (draft) => {
                return draft.body || <em>No message</em>;
              },
            },
            {
              label: 'Created',
              selector: (draft) => {
                return (
                  <Timestamp
                    time={moment(draft.timestamp).toISOString()}
                    relative
                  />
                );
              },
            },
            {
              label: '',
              selector: (draft) => {
                return (
                  <FlexBox>
                    <IconButton
                      variant="tertiary"
                      icon="pen"
                      onClick={() => handleEdit(draft)}
                    />

                    <IconButton
                      variant="tertiary"
                      icon="trash"
                      onClick={() => handleRemove(draft)}
                    />
                  </FlexBox>
                );
              },
              style: {
                width: 0,
              },
            },
          ]}
          tableStatusProps={{
            emptyState:
              emailDraftsV2.length === 0
                ? {
                    title: 'No email drafts',
                    description: "You haven't saved any email drafts yet.",
                  }
                : undefined,
          }}
        />
      </Page.Section>
    </Page>
  );
};
